var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.71314 6.00614L9.35964 3.35964C9.4074 3.31352 9.44549 3.25835 9.47169 3.19735C9.4979 3.13634 9.51169 3.07073 9.51227 3.00434C9.51285 2.93796 9.5002 2.87212 9.47506 2.81067C9.44991 2.74922 9.41279 2.69339 9.36584 2.64645C9.31889 2.5995 9.26307 2.56237 9.20162 2.53723C9.14017 2.51209 9.07433 2.49944 9.00794 2.50002C8.94155 2.5006 8.87594 2.51439 8.81494 2.54059C8.75394 2.5668 8.69877 2.60489 8.65264 2.65264L6.00614 5.29914L3.35964 2.65264C3.26534 2.56157 3.13904 2.51117 3.00794 2.51231C2.87685 2.51345 2.75144 2.56603 2.65873 2.65873C2.56603 2.75144 2.51345 2.87685 2.51231 3.00794C2.51117 3.13904 2.56157 3.26534 2.65264 3.35964L5.29914 6.00614L2.65264 8.65264C2.60489 8.69877 2.5668 8.75394 2.54059 8.81494C2.51439 8.87594 2.5006 8.94155 2.50002 9.00794C2.49944 9.07433 2.51209 9.14017 2.53723 9.20162C2.56237 9.26307 2.5995 9.31889 2.64645 9.36584C2.69339 9.41279 2.74922 9.44991 2.81067 9.47506C2.87212 9.5002 2.93796 9.51285 3.00434 9.51227C3.07073 9.51169 3.13634 9.4979 3.19735 9.47169C3.25835 9.44549 3.31352 9.4074 3.35964 9.35964L6.00614 6.71314L8.65264 9.35964C8.74694 9.45072 8.87325 9.50112 9.00434 9.49998C9.13544 9.49884 9.26085 9.44626 9.35355 9.35355C9.44626 9.26085 9.49884 9.13544 9.49998 9.00434C9.50112 8.87325 9.45072 8.74694 9.35964 8.65264L6.71314 6.00614Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.e42a8e9ea13dba6a6aea14324dda408d.svg";
export { ForwardRef as ReactComponent };